import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Calculator, MessageSquare } from 'lucide-react';
// Array de bonos actualizado con la Calculadora de Excel
const bonuses = [{
  title: 'Pack de Scripts de Venta para WhatsApp',
  description: 'Guiones exactos de "copiar y pegar" probados en negocios venezolanos. Diseñados psicológicamente para manejar objeciones y cerrar ventas sin que te dejen en visto.',
  value: '$19',
  image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_m9n9i7m9n9i7m9n9.jpg?v=1773379810',
  icon: MessageSquare
}, {
  title: 'Calculadora Anti-Inflación (Excel)',
  description: 'Nuestra herramienta estrella. Olvídate de perder dinero por la tasa del día. Carga tus costos en dólares y obtén el precio exacto en Bolívares al instante.',
  value: '$27',
  image: 'https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_1dn20q1dn20q1dn2.jpg?v=1773379810',
  icon: Calculator
}];
export function Bonuses() {
  return <section className="relative py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-13">
      {/* Brillo de fondo central */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-14" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="text-center mb-16 relative z-10" data-id="element-15">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-16">
          <Gift className="w-4 h-4" data-id="element-17" /> Regalos Exclusivos
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight" data-id="element-18">
          ¡Y eso no es todo! Llévate estos bonos{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400 drop-shadow-[0_0_15px_rgba(34,211,238,0.4)]" data-id="element-19">
            100% GRATIS
          </span>
        </h2>
        <p className="text-gray-400 mt-4 text-lg max-w-2xl mx-auto font-light" data-id="element-20">
          Solo por adquirir tu Toolkit el día de hoy, te incluimos estas
          herramientas premium para automatizar tu rentabilidad.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 relative z-10" data-id="element-21">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: index * 0.2
      }} className="group relative bg-[#0a0a0a] border border-white/10 rounded-3xl overflow-hidden hover:border-cyan-500/40 transition-all duration-500 shadow-2xl flex flex-col" data-id="element-22">
            {/* Etiqueta de GRATIS */}
            <div className="absolute top-4 right-4 bg-gradient-to-r from-cyan-400 to-green-400 text-black font-black text-sm px-5 py-2 rounded-full z-20 shadow-lg transform rotate-3 group-hover:scale-110 transition-transform duration-300" data-id="element-23">
              ¡GRATIS HOY!
            </div>

            {/* Imagen del Bono */}
            <div className="relative w-full aspect-square overflow-hidden border-b border-white/10" data-id="element-24">
              <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-25" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent z-10 opacity-60" data-id="element-26" />
            </div>

            {/* Contenido */}
            <div className="relative z-20 p-8 flex-1 flex flex-col justify-between bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a] to-transparent" data-id="element-27">
              <div data-id="element-28">
                <h3 className="font-heading text-2xl font-bold text-white mb-3 tracking-tight group-hover:text-cyan-400 transition-colors duration-300" data-id="element-29">
                  <span className="text-cyan-500 mr-2 text-lg uppercase block mb-1" data-id="element-30">
                    Bono {index + 1}:
                  </span>
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed mb-6 text-lg font-light" data-id="element-31">
                  {bonus.description}
                </p>
              </div>

              {/* Valor Real */}
              <div className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3 text-sm text-gray-300 w-fit" data-id="element-32">
                <span data-id="element-33">Valorado en:</span>
                <span className="text-rose-400 line-through font-bold text-lg" data-id="element-34">
                  {bonus.value}
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}